import React from "react"
import "./style.scss"
import Accordion from "react-bootstrap/Accordion"
import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
import Arrow from "../../../images/Icon-arrowDown.svg"
import ContactSection from "../contact/Contact"
const Toggle = ({ children, eventKey }) => {
  const decoratedOnClick = useAccordionToggle(eventKey, () => {
    console.log(eventKey, "clicked")
  })

  return <div onClick={decoratedOnClick}>{children}</div>
}
const FaqItem = ({ title, content, indx }) => {
  return (
    <Accordion className="faq-item" eventKey={indx}>
      <div className="toggle-top">
        <p>{title}</p>
        <Toggle eventKey={indx}>
          <img src={Arrow} alt="arrow" className="arrow" />
        </Toggle>
      </div>
      <Accordion.Collapse eventKey={indx}>
        <div className="faq-item-content">{content}</div>
      </Accordion.Collapse>
    </Accordion>
  )
}
const InquireSection = ({
  btnBg,
  btnColor,
  faq,
  title,
  subtitle,
  withoutFaqText,
  contactDescription,
  contactTitle,
  className,
  handleNumberSelect,
  getCountryCode,
  details,
  onChange,
  onCheck,
  submit,
}) => {
  const data = {
    inquireDescription:
      "Are you looking to propel your business growth? Then connect with us at Wersel Workdesk. Our suite of power packed brand \nanalytics and business intelligence solutions is sure to transform your business.",
  }
  let faqListOne = []
  let faqListTwo = []
  if (faq) {
    faqListOne = faq.slice(0, 3)
    faqListTwo = faq.slice(3)
  }
  return (
    <div className="inquire-section">
      <div className="header-top">
        <h1>{title}</h1>
        <p>{subtitle}</p>
        <h3 className="faq-title">FAQ</h3>
      </div>
      {faq && (
        <div className="faqs">
          <div className="one">
            {faqListOne &&
              faqListOne.map((faq, idx) => (
                <FaqItem
                  title={faq.question}
                  content={faq.answer}
                  indx={idx + 1}
                  key={idx}
                />
              ))}
          </div>
          <hr className="separator" />
          <div className="two">
            {faqListTwo &&
              faqListTwo.map((faq, idx) => (
                <FaqItem
                  title={faq.question}
                  content={faq.answer}
                  indx={idx + 1}
                  key={idx}
                />
              ))}
          </div>
        </div>
      )}
      {!withoutFaqText && (
        <p className="faq-text">
          For detailed <strong>FAQ</strong> on our feature / product{" "}
          <a href="#/">Click Here</a>
        </p>
      )}

      <ContactSection
        btnBg={btnBg}
        btnColor={btnColor}
        contactDescription={contactDescription || data.inquireDescription}
        contactTitle={contactTitle}
        className={className}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {!withoutFaqText && <hr className="mt-5 mb-5" />}
    </div>
  )
}
InquireSection.defaultProps = {
  title: "Still Thinking? Let us Help",
  subtitle: "Trusted By Best Brands in the world",
}

export default InquireSection
